<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#3CB9D5"
      text-color="#FFFFFF"
      active-text-color="#ffd04b"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";

export default {
  components: { SidebarItem, ScrollBar },
  data() {
    return {
      newArr: [],
    };
  },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    routes() {
      let newArr = JSON.parse(JSON.stringify(this.routers));
      newArr.forEach((item) => {
        // newArr.push(item);
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            if (item.children[i].hidden) {
              item.children.splice(i, 1);
              i = i - 1;
            }
          }
        }
      });
      return newArr;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },

  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue